export const TAB_SOURCES = {
  Unsplash: "Unsplash",
  Library: "Library",
  Link: "Link",
  Attachments: "Attachments",
  Video: "Video",
  Users: "Users",
};
